import { LOCAL_STORAGE_FEATURE_NAME } from './const';

export const getFeatureFlagsFromLS = () => {
  try {
    const localStorageFlags = JSON.parse(localStorage.getItem(LOCAL_STORAGE_FEATURE_NAME) || '');
    return localStorageFlags;
  } catch (error) {
    return {};
  }
};
